import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { ConfigurationService } from '../services/configuration.service';

@Injectable()
export class GasService {
    private _authService: AuthService;

    constructor(private http: HttpClient, private injector: Injector) { }

    private get authService() {
        if (!this._authService)
            this._authService = this.injector.get(AuthService);

        return this._authService;
    }

    get() {
        return this.http.get('api/Gas', this.getAuthHeader(true));
    }

    getDataListByPage(page: number, pagesize: number, orderBy: string, isDesc: boolean, search?: string) {
        if (search != null && search !== '') {
            return this.http.get(`api/Gas/GetDataListByPage/${page}/${pagesize}/${orderBy}/${isDesc}/${search}`, this.getAuthHeader(true));
        }
        return this.http.get(`api/Gas/GetDataListByPage/${page}/${pagesize}/${orderBy}/${isDesc}`, this.getAuthHeader(true));
    }

    getLastUpdateDate() {
        return this.http.get('api/Gas/GetLastUpdateDate', this.getAuthHeader(true));
    }

    getStatistics(monthsCount: number) {
        return this.http.get('api/Gas/GetStatistics/' + monthsCount, this.getAuthHeader(true));
    }

    getCacheStatistics(monthsCount: number) {
        return this.http.get('api/Gas/getCacheStatistics/' + monthsCount, this.getAuthHeader(true));
    }

    getAllResultStatistics(monthsCount: number) {
        return this.http.get('api/Gas/GetResultSetStatistics/' + monthsCount, this.getAuthHeader(true));
    }

    public getAuthHeader(includeJsonContentType?: boolean) {
        let headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.authService.accessToken });

        if (includeJsonContentType)
            headers.append("Content-Type", "application/json");

        headers.append("Accept", 'application/json');
        headers.append("App-Version", ConfigurationService.appVersion);

        var options = {
            headers: headers
        };

        return options;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/services/gas.service.ts